import { IPriceSearchBody } from '../get-prices-by-pharmacies/get-prices-by-pharmacies';

export const DrugSearchApiErrors = {
  drugSearch: (filter: string) => `Error getting drug search for filter ${filter}`,
  drugSearchNdc: (ndc: string) => `Error getting drug search for ndc ${ndc}`,
  getPricesByPharmacies: (body: IPriceSearchBody) =>
    `Error getting prices by pharmacies for ndc ${body.productId} with quantity ${body.quantity} and daysSupply ${body.daysSupply}`,
  getPharmacyByNpi: (npi: string) => `Error getting pharmacy by NPI for npi ${npi}`,
};
